import React from 'react';

import lessRequire from '../../../config/less-require-resolver';

import withIntl from '../../shared/intl-hoc';

import { Field, reduxForm } from 'redux-form';

import SelectField from '../../shared/form-elements/multiselect/select';

lessRequire('modules/finances/components/categories-filter.less');

const PayoutSystemsFilter = ({ intl, options }) => (
	<form className="finances-categories-filter" action="#">
		<div className="finances-categories-filter__item">
			<Field
				name="system"
				placeholder={intl('Способ вывода')}
				component={SelectField}
				options={options}
				multi={false}
			/>
		</div>
	</form>
);

export default reduxForm({ form: 'payoutSystemsFilter' })(withIntl(PayoutSystemsFilter));


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/finances/components/payout-systems-filter.js